import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ItemPromotionService {

  environment = EnvironmentService.environment;

  //Variables
  selectedPromotion: any;

  // Subjects
  public promotionEditSubject: Subject<any> = new Subject();
  public promotionUpsertSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setPromotionEditSubject = (value: any) => { this.promotionEditSubject.next(value); };
  setPromotionUpsertSubject = (value: any) => { this.promotionUpsertSubject.next(value); };

  // Observables
  getPromotionEditSubject = () => this.promotionEditSubject.asObservable();
  getPromotionUpsertSubject = () => this.promotionUpsertSubject.asObservable();


  constructor(private http: HttpClient) {
  }


  CreatePromotion(promtion: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotion}/add`, promtion)
      .pipe(map(data => {
        return data;
      }));
  }

  UpdatePromotionItem(promotion: any) {
    return this.http.put(`${this.environment.AppItemPromotion}/update`, promotion)
      .pipe(map(data => {
        return data;
      }));
  }

  DeletePromotionItem(promotionId: string) {
    return this.http.delete(`${this.environment.AppItemPromotion}/delete?PromotionId=${promotionId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetAllPromotionItems(offSet: number, pageSize: number) {
    return this.http.get(`${this.environment.AppItemPromotion}/getlist`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetFilterPromotionItemList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/getlist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetFilterPromotionItemDetailList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/getpromotiondetailapprovallist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkAddPromotionDetailItems(body: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotion}/bulkaddpromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  FilterPromotionDetailItemList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/getpromotiondetaillist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkUpdatePromotionDetailItems(body: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotion}/bulkupdatepromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  GetPromotionsDetailItemsApprovalList(offSet = 0, pageSize = 100) {
    return this.http.get(`${this.environment.AppItemPromotion}/getpromotiondetailapprovallist`)
    .pipe(map(data => {
      return data;
    }));
  }
  
  GetPromotionItemDetailWeeklyForecastList() {
    return this.http.get<any>(`${this.environment.AppItemPromotion}/GetPromotionItemDetailWeeklyForecastList`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkUpdatePromotionItemWeeklyForecastList(promotion: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotion}/BulkUpdatePromotionDetailWeeklyForecast`, promotion)
      .pipe(map(data => {
        return data;
      }));
  }

  FilterPromotionsDetailItemsApprovalList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/getpromotiondetailapprovallist?${query}`)
    .pipe(map(data => {
      return data;
    }));
  }

  FilterPromotionItemDetailWeeklyForecastList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/GetPromotionItemDetailWeeklyForecastList?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetPromotionItemDetailWeeklyForecastNewItemPromoList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/GetPromotionItemDetailWeeklyForecastNewItemPromoList?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  CheckDuplicatePromotionItem(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotion}/CheckDuplicatePromotionItem?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  ImportNewItemPromotionDataTemplate(body: any) {
    return this.http.post(`${this.environment.AppItemPromotion}/import`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  ImportNewItemPromotionsList(body: any) {
    return this.http.post(`${this.environment.AppItemPromotion}/ImportNewItemPromotionsList`, body)
      .pipe(map(data => {
        return data;
      }));
  }

}
